import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Transaction } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import ReclassificationOperationTableRow from './ReclassificationOperationTableRow';

const ReclassificationOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const transactions: Transaction[] =
    (data.operation?.transactions as Transaction[]) || [];
  const hasData = transactions.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {transactions?.map((transaction: Transaction, index: number) => (
            <tr
              className="nk-tb-item"
              // eslint-disable-next-line react/no-array-index-key
              key={`reclassification-data-row-${index}`}
            >
              <ReclassificationOperationTableRow
                index={index}
                transaction={transaction}
              />
            </tr>
          ))}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={7}
        />
      )}
    </>
  );
};

export default ReclassificationOperationTableBody;
